export const STORAGE_KEYS = {
  resume: 'cv-creator/resume/v1',
  coverLetter: 'cv-creator/cover-letter/v1',
  settings: 'cv-creator/settings/v1',
} as const;
